import { render } from "./PrayerModal.vue?vue&type=template&id=0bc8a2bb&scoped=true"
import script from "./PrayerModal.vue?vue&type=script&lang=js"
export * from "./PrayerModal.vue?vue&type=script&lang=js"

import "./PrayerModal.vue?vue&type=style&index=0&id=0bc8a2bb&scoped=true&lang=css"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc8a2bb"]])

export default __exports__